const css = `.YXMaSq__guideline line{stroke:var(--base-strokes-default);stroke-opacity:.7;shape-rendering:crispedges}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"guideline":"YXMaSq__guideline"};
